import type { StationRequestRecord } from "../../../services/FormService";

/** Legal / registered business name (not the public station title). */
export function resolveStationRequestBusinessName(
	request?: StationRequestRecord | null
): string {
	const pi = request?.partnerInfo || {};
	const ci = request?.contractInfo || {};
	const ext = (request?.extenalInfo || {}) as {
		stationPortalLegalVerification?: { businessName?: string };
	};
	const venueName = String(
		pi.hotelName || pi.name || pi.displayName || ""
	).trim();
	const legalBusinessName = String(
		ci?.businessLegalName || (ci as { businessName?: string })?.businessName || ""
	).trim();
	const partnerBusinessName = String(
		(pi as { businessName?: string }).businessName || ""
	).trim();
	const portalBusinessName = String(
		ext?.stationPortalLegalVerification?.businessName || ""
	).trim();

	if (legalBusinessName) return legalBusinessName;
	if (partnerBusinessName && partnerBusinessName !== venueName) return partnerBusinessName;
	if (portalBusinessName && portalBusinessName !== venueName) return portalBusinessName;
	return "";
}

/** Public hotel or station title (venue). */
export function resolveStationRequestVenueName(
	request?: StationRequestRecord | null
): string {
	const pi = request?.partnerInfo || {};
	return String(
		pi.hotelName || pi.name || pi.displayName || ""
	).trim();
}

export function resolveStationRequestRepresentativeName(
	request?: StationRequestRecord | null
): string {
	const pi = request?.partnerInfo || {};
	const ci = request?.contractInfo || {};
	return String(ci.ownerFullName || pi.representativeName || "").trim();
}

export function resolveStationRequestRepresentativePhone(
	request?: StationRequestRecord | null
): string {
	const pi = request?.partnerInfo || {};
	const ci = request?.contractInfo || {};
	return String(ci.ownerPhone || pi.representativePhone || pi.phone || "").trim();
}
